module.exports = __webpack_public_path__ + "img/pinkSapphire.71a2e3a.png";